import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { IntegrationFilters, IntegrationsResponse } from "../api/integrationApi";
import { fetchIntegrations } from "../api/integrationApi";

export const integrationsKeys = {
  all: ["integrations"] as const,
  list: (filters: IntegrationFilters) => [...integrationsKeys.all, "list", filters] as const,
};

export const useIntegrationsQuery = (filters: IntegrationFilters) =>
  useQuery<IntegrationsResponse>({
    queryKey: integrationsKeys.list(filters),
    queryFn: () => fetchIntegrations(filters),
    placeholderData: keepPreviousData,
    staleTime: 0,
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
